import React from "react";
import { LocationInspectionSummary, SafetyInspectionLocation, safetyInspectionSummaryHelper } from "../../../../amorg-common";
import { Flex } from "../../../../designSystem/compositeComponents/FlexHelpers";
import { ListRowWithChildren } from "../../../../designSystem/compositeComponents/ListRow";
import { H3 } from "../../../../designSystem/typography/Heading";
import { FacilityPanel } from "./FacilityPanel";
import styled from "styled-components";
import { StatusCounter } from "../../../../designSystem/compositeComponents/StatusCounter";
import { getInspectionPointStatusIconDetails } from '../../../../utils/facilityHelper';

type LocationPanelProps = {
    activityId: string,
    location: SafetyInspectionLocation,
    expanded: boolean,
    onToggleExpand: (locationId: string, expanded: boolean) => void,
    onClickCreate: (locationId: string) => void;
    onUpdate:()=>void
};

export function LocationPanel (props: LocationPanelProps): JSX.Element
{
    const summary = safetyInspectionSummaryHelper.getLocationInspectionSummary(props.location);
    let color = getInspectionPointStatusIconDetails('pending').color;
    if(summary.state === 'completed-all-passed')
        color = getInspectionPointStatusIconDetails('passed').color;
    else if(props.location.facilities.some(f => f.inspectionPoints.some(i => i.inspectionResult.status === 'failed')))
        color = getInspectionPointStatusIconDetails('failed').color;

    return (
        <Flex flexDirection="column">
            <ListRowWithChildren
                sizeVariant='medium'
                styleVariant="normal"
                stripColor={color}
                icon='facility_domain'
                childRows={[
                    props.location.facilities.sort((f1, f2) => f1.name.localeCompare(f2.name)).map(f =>
                    {
                        return (
                            <FacilityPanel key={f.facilityId} activityId={props.activityId} locationId={props.location.locationId} facility={f} onUpdate={props.onUpdate} />
                        );
                    })
                ]}
                expanded={props.expanded}
                onCollapse={
                    props.location.facilities.length > 0
                        ? (expanded: boolean) => props.onToggleExpand(props.location.locationId, expanded)
                        : undefined
                }
                content={
                    <Flex flexDirection='row' gap={24} alignItems="center" style={{ marginLeft: '10px' }}>
                        <H3>{props.location.name}</H3>

                        <StatusOverview summary={summary} facilityCount={props.location.facilities.length} />
                    </Flex>
                } />
        </Flex>
    );
}



type StatusOverviewProps = {
    summary:LocationInspectionSummary,
    facilityCount:number
}
function StatusOverview(props:StatusOverviewProps):JSX.Element
{
    const pending = getInspectionPointStatusIconDetails('pending');
    const passed = getInspectionPointStatusIconDetails('passed');
    const failed = getInspectionPointStatusIconDetails('failed');

    return (
        <Flex flexDirection="column" justifyContent="center">
            <>
                {props.summary.state === 'no-facilities' && props.facilityCount===0 && 
                    <Flex flexDirection="column">
                        <StyledStatusText>Ingen faciliteter oprettet</StyledStatusText> 
                        <StyledStatusText>
                            Klik <a href="/locations">her</a> for at oprette faciliteter
                        </StyledStatusText>
                    </Flex>
                }
                {props.summary.state === 'no-inspections' && <StyledStatusText>Ingen kontrolpunkter oprettet for lokationen</StyledStatusText> }
                {props.summary.state === 'in-progress' && <StyledStatusText>Inspektion af lokationens faciliteter påbegyndt</StyledStatusText> }
                {props.summary.state === 'completed' && <StyledStatusText>Inspektion af lokationens faciliteter gennemført</StyledStatusText> }
                {props.summary.state === 'completed-all-passed' && <StyledStatusText>Inspektion af lokationens faciliteter godkendt</StyledStatusText> }
                
            </>
            {props.summary.total > 0 && props.summary.noInspections !== props.summary.total &&
                <Flex gap={10}>
                    <StatusCounter icon={passed.icon} iconColor={passed.color} text='Godkendt' count={props.summary.allPassed} />
                    <StatusCounter icon={failed.icon} iconColor={failed.color} text='Ikke godkendt' count={props.summary.completed} />
                    <StatusCounter icon={pending.icon} iconColor={pending.color} text='Ikke kontrolleret' count={props.summary.inProgress} />
                    <StatusCounter icon={pending.icon} iconColor={pending.color} text='Ikke påbegyndt' count={props.summary.notStarted} />
                    <StatusCounter icon={pending.icon} iconColor={pending.color} text='Ingen kontrolpunkter oprettet' count={props.summary.noInspections} />
                </Flex>
            }
        </Flex>
    );
}

const StyledStatusText = styled.span`
    font-size: 14px;
    font-weight: 600;
    padding: 4px 0px;
`;